import tenantTheme from '@theme';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Tag } from '../../../../components/common';
import { useRouteNavigate } from '../../../../hooks';
import bundleCards from '../../../../static/img/bundle-banner/bundle-cards.png';
import {
  BannerCards,
  BannerContent,
  BannerHeading,
  BannerHeadingGroup,
  BannerHeadingRow,
  BannerRoot,
  BannerSubtext,
  CtaButton,
} from './BundleBanner.styled';

const BUNDLES_PATH = '/buy-bundles';

/**
 * Promotional banner for the Buy Bundles feature, shown on the All Listings page
 * for bundle-eligible Zameen agencies. Built from Figma node 1:2 (Profolio-banner).
 */
const BundleBanner = () => {
  const { t } = useTranslation();
  const navigate = useRouteNavigate();

  const goToBundles = () => navigate(BUNDLES_PATH);

  return (
    <BannerRoot>
      <BannerContent>
        <BannerHeadingGroup>
          <BannerHeadingRow>
            <BannerHeading>{t('Get instant savings with Credit Bundles')}</BannerHeading>
            <Tag
              color={tenantTheme['danger-color']}
              style={{
                '--tag-color': '#fff',
                '--tag-font-size': '10px',
                borderRadius: '16px',
                fontWeight: 600,
                letterSpacing: '0.412px',
              }}
            >
              {t('NEW')}
            </Tag>
          </BannerHeadingRow>
          <BannerSubtext>
            {t(
              'Get huge discount when you buy credits in bulk. Select a bundle and buy instantly for immediate access to your credits.',
            )}
          </BannerSubtext>
        </BannerHeadingGroup>
        <CtaButton type="button" onClick={goToBundles}>
          {t('Buy Bundles')}
          <Icon icon="FiArrowRight" size="1.15em" />
        </CtaButton>
      </BannerContent>
      <BannerCards src={bundleCards} alt="" aria-hidden="true" />
    </BannerRoot>
  );
};

export default BundleBanner;
